import api from "@/utils/axios";

export const registerUser = async (data) => {
  const res = await api.post("/auth/register", data);
  return res.data;
};

export const loginUser = async (data) => {
  const res = await api.post("/auth/login", data);
  return res.data;
};

export const loginWithGoogle = async ({ idToken }) => {
  const res = await api.post("/auth/google", { idToken });
  return res.data;
};

export const verifyEmail = async ({ email, token, context }) => {
  const res = await api.post("/auth/email/verify", { email, token, context });
  return res.data;
};

export const resendPin = async ({ email }) => {
  const res = await api.post("/auth/email/resend-pin", { email });
  return res.data;
};

export const forgotPassword = async ({ email }) => {
  const res = await api.post("/auth/password/forgot", { email });
  return res.data;
};

export const verifyResetPin = async ({ email, token }) => {
  const res = await api.post("/auth/password/verify-pin", { email, token });
  return res.data;
};

export const resetPassword = async ({ token, newPassword }) => {
  const res = await api.post("/auth/password/reset", {
    token,
    newPassword,
  });
  return res.data;
};

export const changePassword = async ({ currentPassword, newPassword }) => {
  const res = await api.post("/auth/password/change", {
    currentPassword,
    newPassword,
  });
  return res.data;
};

export const logoutUser = async ({ refreshToken }) => {
  const res = await api.post("/auth/logout", { refreshToken });
  return res.data;
};
